import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
    selector: 'rounded-checkbox',
    templateUrl: './rounded-checkbox.component.html',
    styleUrls: ['./rounded-checkbox.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RoundedCheckboxComponent),
            multi: true
        }],
    standalone: false
})
export class RoundedCheckboxComponent implements ControlValueAccessor  {

  constructor() { }

  onChange = (_ => { });
  onBlur = (_ => { }); 
  
  writeValue(obj: boolean): void {
    this.checked = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onBlur = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  
  @Input() disabled = false;
  @Input() small = false;
  id = Math.random().toString(36).substring(2);
  @Input() checked:boolean;
  
  ngOnInit(): void {
  }

  onModelChange($event) {
    this.checked = $event
    this.onChange(this.checked);
  }

}
